/**
 * Feed Type Options Builder
 * Extracted from feeds.list.js for use in React components
 */

import { getFeedTypeOptions } from '../data/feedsRepo';

export type UserMode = 'CDC' | 'CE' | 'VERITY';

/**
 * Helper function to convert feed type options to table filter options format
 */
export function feedTypeOptionsForTable(usrMode: string): Array<{ lbl: string; val: string }> {
    const types = getFeedTypeOptions(usrMode);
    return [...types.map(type => ({ lbl: type, val: type }))];
}
